import React from 'react';
import {Button} from '~/components/Button';
import {ID} from '~/lib/model';
import {notify} from '~/lib/notify';
import {fetchPlacementFormatsProposal} from '~/modules/Bidders/api';
import {IPlacementFormatsProposal} from '~/modules/Bidders/models/PlacementFormatsProposal';

export interface IFillFromRulesButtonProps {
    bidderId: ID;
    disabled?: boolean;
    onProposal: (proposal: IPlacementFormatsProposal) => void;
}

export const FillFromRulesButton = ({bidderId, disabled, onProposal}: IFillFromRulesButtonProps) => {
    const [loading, setLoading] = React.useState(false);
    const fill = async () => {
        setLoading(true);
        try {
            onProposal(await fetchPlacementFormatsProposal(bidderId));
        } catch (error) {
            notify.apiError(error, 'Failed to load placement formats proposal.');
        } finally {
            setLoading(false);
        }
    };
    return <Button disabled={disabled || loading} onClick={() => void fill()}>Fill from rules</Button>;
};
